import axios from "axios";
import Config from "@/config"
import { $store } from "@/main"

export default async function request(method, configKey, path = "", params = {}, data = {}) {
    const options = {
        url: Config.proxy + Config.url(configKey) + path,
        method: method,
        headers: { ...Config.headers($store.getters["userdata/getAccessToken"]) },
        params,
        data
    };
    return axios({ ...options }) 
        .then(res => res.data)
        .catch(
            function (error) {
            console.log('Show error notification!')
            return Promise.reject(error)
            }
        )
}
    